import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, LegacyForm, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { ValidUrl } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useIsSiteRequired } from "@/mobile/Settings/Business/Edit/utils/useIsSiteRequired";
import { useIsSiteDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsSiteDisabled";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsBusinessAtom } from "../../state";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessWebsite: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const siteApi = useAppSelector((state) => state.user.businessInfo?.site);
  const isSiteRequired = useIsSiteRequired();
  const isSiteDisabled = useIsSiteDisabled();

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.websiteAddress")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={(values) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.taxCode.url,
                fieldName: "site",
                fieldValue: values.site,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ site: mobileFormEditState.site ?? siteApi }}
          >
            <LegacyForm.Url
              form={form}
              className={"tw:dir-ltr!"}
              label={t("settings.business.websiteAddress")}
              rules={[
                { required: isSiteRequired },
                ({ getFieldValue }) => ({
                  validator(): Promise<void> {
                    const url = getFieldValue("site");
                    return url && !ValidUrl(url) ? Promise.reject(t("error.url")) : Promise.resolve();
                  },
                }),
              ]}
              name={"site"}
              placeholder={"payping.ir"}
              disabled={isSiteDisabled}
            />
          </LegacyForm>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress1")}</Typography.Text>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress2")}</Typography.Text>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress3")}</Typography.Text>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress4")}</Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessWebsite;
